export const sanitizePhoneNumber = (value) =>
  String(value || "")
    .replace(/\D/g, "")
    .slice(0, 11);

export const sanitizeToken = (value) =>
  String(value || "")
    .trim()
    .replace(/[^a-zA-Z0-9_-]/g, "");

export const isValidEmail = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());

const PLATE_OLD_REGEX = /^[A-Z]{4}\d{2}$/;
const PLATE_NEW_REGEX = /^[A-Z]{2}[- ]?[A-Z]{2}[- ]?\d{2}$/i;

export const validateRut = (rawRut) => {
  const rut = String(rawRut || "")
    .replace(/\./g, "")
    .replace(/-/g, "")
    .trim()
    .toUpperCase();
  if (rut.length < 2) return false;
  const body = rut.slice(0, -1);
  const dv = rut.slice(-1);
  if (!/^\d+$/.test(body)) return false;
  let sum = 0;
  let multiplier = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i], 10) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }
  const remainder = 11 - (sum % 11);
  const expectedDv =
    remainder === 11 ? "0" : remainder === 10 ? "K" : String(remainder);
  return dv === expectedDv;
};

export const validatePlate = (plate) => {
  const cleaned = String(plate || "")
    .trim()
    .toUpperCase()
    .replace(/[- ]/g, "");
  return (
    PLATE_OLD_REGEX.test(cleaned) ||
    PLATE_NEW_REGEX.test(
      String(plate || "")
        .trim()
        .toUpperCase()
    )
  );
};
